import API from '../';

export const profilesAPI = new API('/perfiles');
